import React from 'react'
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import Menu from './shared/menu/Menu';
import '../styles/style.css';
import {isUserLoggedIn}  from '../helpers/auth';
const PrivateRoute = ({ component: Component, ...rest }) => {

  // Add your own authentication on the below line.
  const isLoggedIn = isUserLoggedIn();

  return (
    <Route
      {...rest}
      render={props =>
        isLoggedIn ? (
          <div>
            <Menu />
            <div className="content">
              <Component {...props} />
            </div>
          </div>
        ) : (
            <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
          )
      }
    />
  )
}


PrivateRoute.propTypes = {
  location: PropTypes.object,
  component: PropTypes.func
}

export default PrivateRoute;
